import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SectionItemDto } from '../../../core/models/cms.model';
import { MediaSrcDirective } from '../../directives/media-src.directive';
import { MediaSlotComponent } from '../media-slot/media-slot.component';
import { TranslatePipe } from '../../../core/pipes/t.pipe';
import { PROMO_TRIPLE_SLOTS, GridSlotPreset } from '../../../core/constants/grid-layout-presets';
import { mediaProfileForSlotHint, sizesForSlotHint, MEDIA_SIZES_THIRD } from '../../../core/utils/media-image-profile.util';

@Component({
  selector: 'app-promo-triple',
  standalone: true,
  imports: [CommonModule, RouterModule, MediaSrcDirective, MediaSlotComponent, TranslatePipe],
  templateUrl: './promo-triple.component.html',
  styleUrls: ['./promo-triple.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromoTripleComponent {
  readonly slots = PROMO_TRIPLE_SLOTS;

  @Input({ required: true }) items: SectionItemDto[] = [];

  mediaProfileForSlot(slot: GridSlotPreset) {
    return mediaProfileForSlotHint(slot.hintPx);
  }

  sizesForSlot(slot: GridSlotPreset): string {
    return sizesForSlotHint(slot.hintPx, MEDIA_SIZES_THIRD);
  }

  cellItem(sortOrder: number): SectionItemDto | undefined {
    return this.items.find((i) => i.sortOrder === sortOrder);
  }

  cellLink(item: SectionItemDto | undefined): string | null {
    const url = item?.linkUrl?.trim();
    return url || null;
  }

  trackBySortOrder(_: number, slot: (typeof PROMO_TRIPLE_SLOTS)[number]): number {
    return slot.sortOrder;
  }
}
